import { jwtDecode } from 'jwt-decode';
import { InstanceValues } from '../types/instance';

export const decodeInstance = (instance = '') => {
  try {
    const decodedInstance = jwtDecode<InstanceValues>(instance);
    return {
      siteIsTemplate: Boolean(decodedInstance.siteIsTemplate) || false,
      demoMode: Boolean(decodedInstance.demoMode) || false,
    };
  } catch (e) {
    return {
      siteIsTemplate: false,
      demoMode: false,
    };
  }
};
